@let shouldPresentData =
  allocationsFeature.selectors.shouldPresentData.asSignal();
@let shouldPresentLoading =
  allocationsFeature.selectors.shouldPresentLoading.asSignal();
@let error = allocationsFeature.selectors.error.asSignal();
@let outcomes = allocationsFeature.selectors.outcomes.asSignal();
@let units = allocationsFeature.selectors.units.asSignal();
@let assignments = allocationsFeature.selectors.assignments.asSignal();

<atn-ds-page>
  <atn-ds-page-header>
    <i
      actions
      class="atn-icon atn-funnel atn-blue"
      (click)="layoutStore.patchState({ presentFilters: true })"
    ></i>
  </atn-ds-page-header>

  @if (shouldPresentData) {
    <atn-summit-allocation-graph
      [outcomes]="outcomes"
      [units]="units"
      [unitOutcomeAssignments]="assignments"
      (outcomeLinkClicked)="onOutcomeLinkClicked($event)"
    />
  } @else if (shouldPresentLoading) {
    ... loading ...
  } @else if (error) {
    error: {{ error }}
  }
</atn-ds-page>
<atn-allocation-filters-slideout />
